import React from 'react';
import {useState,useContext} from 'react';
import { useAlert } from 'react-alert';
import { useNavigate } from 'react-router-dom';
import {UserContext} from '../context/UserContext';

const Login = () => {
    const navigate = useNavigate();
    const alert = useAlert();
    const {loginUser, wait, loggedInCheck} = useContext(UserContext);
    const [redirect, setRedirect] = useState<string>('');
    const [errMsg, setErrMsg] = useState<string>('');
    const [formData, setFormData] = useState({
        email:'',
        password:''
    });

    const onChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.name]:e.target.value
        })
    }

    const submitForm = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if(!Object.values(formData).every(val => val.trim() !== '')){
            setErrMsg('Kérlek tölts ki mindent kötelező mezőt!');
            return;
        }

        const data = await loginUser(formData);
        if(data.success){
            const form = e.target as HTMLFormElement;
            form.reset();
            setRedirect('Redirecting...');
            await loggedInCheck();
            return navigate('/');
        }
        alert.error("Helytelen felhasználónév vagy jelszó.")
        setErrMsg(data.message);
    }

    return (
        <div className="myform">
            <h2>Bejelentkezés</h2>
            <form onSubmit={submitForm}>
                <label htmlFor="email">Email:</label>
                <input type="email" name="email" onChange={onChangeInput} placeholder="Email" id="email" value={formData.email} required />
                <label htmlFor="password">Jelszó:</label>
                <input type="password" name="password" onChange={onChangeInput} placeholder="Jelszó" id="password" value={formData.password} required />
                {errMsg && <div className="err-msg">{errMsg}</div>}
                {redirect ? redirect : <button type="submit" disabled={wait}>Bejelentkezés</button>}
            </form>
        </div>
    )
}

export default React.memo(Login);